<template>
  <div>
    <h5 class="mb-2">
      {{ dataComponent.name }}
    </h5>

    <!-- Tabs -->
    <div class="tabs mt-4">
      <div
        v-for="(tab, index) in tabs"
        :key="tab"
        :class="{'tab-active': index === 0}"
        class="tab-list"
      >
        {{ tab }}
      </div>
    </div>

    <!-- Form -->
    <b-row class="mt-3">
      <b-col cols="9">
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label class="bold">Date</label>
            </b-col>
            <b-col cols="9">
              <b-row>
                <b-col cols="6">
                  <label>From</label>
                  <j-datepicker
                    :disabled="true"
                    format="MMM dd, yyyy"
                    placeholder="Ex. Jan 01, 2019"
                  />
                </b-col>
                <b-col cols="6">
                  <label>To</label>
                  <j-datepicker
                    :disabled="true"
                    format="MMM dd, yyyy"
                    placeholder="Ex. Jan 01, 2019"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Employee Name</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                placeholder="Select Employee"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Project</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                placeholder="Select Project"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <label class="mt-3">Task</label>
              <br>
              <p style="font-weight: 400; font-size: 11px;">
                <span style="font-weight: 600; color: #4a90e2;">16</span> Total Task
              </p>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                placeholder="Select Task"
              />
              <b-button
                class="btn blue"
              >
                <i class="fa fa-search mr-2" />Search
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <hr>

    <div class="d-flex justify-content-end">
      <b-button class="btn green">
        <i class="fa fa-download" /> Generate Report XLS
      </b-button>
    </div>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      tabs: [
        'Timesheet',
        'Form Project',
      ],
      columns: [
        'PROJECT NAME',
        'TOTAL TASK',
        'DURATION',
        'SUBMITED DATE',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: scroll;

  .tab-list {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    color: $gray-1;
    white-space: nowrap;
    padding-bottom: 7px;
    margin-right: 20px;
    border-bottom: 4px solid transparent;

    &.tab-active {
      border-color: $primary;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyTimesheetReport.vue